import { faRectangleList, faUpload } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeStyles } from "@material-ui/core/styles";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Alert,
  Button,
  Card,
  TextField,
  Typography,
} from "@mui/material";
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Icon } from "@progress/kendo-react-common";
import axios from "axios";
import moment from "moment";
import { useAuth } from "oidc-react";
import React, { Fragment, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import {
  ShowError,
  ShowSucess,
  getUserRole,
  removeKeyFromObjects,
} from "../../_helper/helper";
import { loadingPanel } from "../../CommonComponents/CommonFunction";
import Depedentinformation from "./Components/Depedentinformation";
import Errorlable from "./Components/Errorlable";
import CoverageEmployeeSign from "./CoverageEmployeeSign";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    ".&.MuiExpansionPanelSummary-content": {
      padding: 0,
    },
    ".css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "32px",
      margin: "0px !important",
    },
    "& .MuiPaper-root": {
      background: "none",
      display: "block",
    },

    margin: "0 !important",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
  },
  asterisk: {
    color: "red !important",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "70%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
}));

const CoverageMain = () => {
  const classes = useStyles();
  const { EmployeeId } = useParams();

  //Signature Properties
  const [openCanvas, setOpenCanvas] = useState(false);

  const closeCanvas = () => {
    setOpenCanvas(false);
  };


  const plan = {
    Zender: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
      { value: "Other", label: "Other" },
    ],
    basic_plan: "Basic Life Insurance",
    basic_amount: "10000",
    basic_description: "Basic Life with AD&D $10,000 (Employer Paid) ",

    additional_plan: "Additional/Optional Life Insurance",
    additional_plan_decline: "Decline Additional/Optional Life with AD&D ",
    additional_amount: "10000",
    additional_description: "Basic Life with AD&D $10,000 (Employer Paid) ",
    additional_line1:
      "You may choose one of the following options for yourself:",
    additional_select:
      "Additional/Optional Life with AD&D (Employee Paid) (See Coverage Highlights for bi-weekly age-banded premium rates)",
    additional_amount: [
      { value: 30000, label: "$30,000" },
      { value: 35000, label: "$35,000" },
      { value: 40000, label: "$40,000" },
      { value: 45000, label: "$45,000" },
      { value: 50000, label: "$50,000" },
      { value: 55000, label: "$55,000" },
      { value: 60000, label: "$60,000" },
      { value: 65000, label: "$65,000" },
      { value: 70000, label: "$70,000" },
      { value: 75000, label: "$75,000" },
      { value: 80000, label: "$80,000" },
      { value: 85000, label: "$85,000" },
      { value: 90000, label: "$90,000" },
      { value: 95000, label: "$95,000" },
      { value: 100000, label: "$100,000" },
      { value: 105000, label: "$105,000" },
      { value: 110000, label: "$110,000" },
      { value: 115000, label: "$115,000" },
      { value: 120000, label: "$120,000" },
      { value: 125000, label: "$125,000" },
      { value: 130000, label: "$130,000" },
    ],
    dependents_plan: "Dependents Life Insurance",
    dependents_amount: "18000",
    dependents_decline: "Decline Spouse Life / Child(ren) Life",
    dependents_description:
      "Spouse Life $10,000 / Child(ren) Life $8,000 (Employee Paid) (See Coverage Highlights for bi-weekly premiums)",
  };

  const basicInsurance = {
    ratio: 0,
    lastName: "",
    firstName: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    selectSource: "",
    email: "",
    middleName: "",
  };

  const basicContingentInsurance = {
    ratio: 0,
    lastName: "",
    firstName: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    selectSource: "",
    email: "",
    middleName: "",
  };

  const optionalInsurance = {
    ratio: 0,
    lastName: "",
    firstName: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    selectSource: "",

    email: "",
    middleName: "",
  };

  const optionaloContingentInsurance = {
    ratio: 0,
    lastName: "",
    firstName: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    selectSource: "",

    email: "",
    middleName: "",
  };

  const dependInsurance = {
    ratio: 0,
    lastName: "",
    firstName: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    selectSource: "",
    email: "",
    middleName: "",
  };

  const dependContingentInsurance = {
    ratio: 0,
    lastName: "",
    firstName: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    selectSource: "",
    email: "",
    middleName: "",
  };
  const [dependentInformation, setDependentInformation] = useState({});
  const [allDependent, setALLDependent] = useState([]);
  const [basicDependent, setBasicDependant] = useState([basicInsurance]);
  const [basicDependentContingent, setBasicDependantContingent] = useState([
    basicContingentInsurance,
  ]);
  const [preDependent, setPreDependent] = useState([]);
  const [additionInsurance, setAdditionInsurance] = useState([
    optionalInsurance,
  ]);
  const [additionInsuranceContingent, setAdditionInsuranceContingent] =
    useState([optionaloContingentInsurance]);
  const [dependentInsurance, setDependentInsurance] = useState([
    dependInsurance,
  ]);
  const [dependentInsuranceContingent, setDependentInsuranceContingent] =
    useState([dependContingentInsurance]);
  const [deletedDependent, setdeletedDependent] = useState([]);
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [dataObject, setDataObject] = useState({});
  const [mainfinalSetValueid, setmainfinalSetValueid] = useState(null);
  const [expanded, setExpanded] = React.useState({
    empDetail: true,
    healthandDeduction: true,
    dependent: true,
  });
  const [loding, setLoading] = useState(false);

  const navigate = useNavigate();
  const { userData } = useAuth();

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handlePrefill = (value, index, type) => {
    // let getinf = allDependent.find((i) => i.id == value);
    let getinf = allDependent.find((i) => i.rowId == value);



    if (getinf) {
      let update = [];
      if (type == "dependentInsurance") {
        update = [...dependentInsurance];
      } else if (type == "additionInsurance") {
        update = [...additionInsurance];
      } else if (type == "basicDependent") {
        console.log("dsadsadsadasd", value);
        update = [...basicDependent];
      } else if (type == "basicContingentDependent") {
        update = [...basicDependentContingent];
      } else if (type == "additionContingentInsurance") {
        update = [...additionInsuranceContingent];
      } else if (type == "dependentContingentInsurance") {
        update = [...dependentInsuranceContingent];
      }

      let indexupdate = update[index];
      indexupdate.firstName = getinf.FirstName;
      indexupdate.dob = getinf.DOB;
      indexupdate.middleName = getinf.MiddleName;
      indexupdate.relation = getinf.Relation;
      // indexupdate.ssn = getinf.ssn;
      indexupdate.lastName = getinf.LastName;
      indexupdate.gender = getinf.Gender;
      indexupdate.email = getinf.Email;
      indexupdate.mailingAddress = getinf.MailingAddress;
      indexupdate.id = getinf.rowId;
      update[index] = indexupdate;

      console.log("index", indexupdate);

      console.log(update, "selected");
      if (type == "dependentInsurance") {
        setDependentInsurance(update);
        console.log("indexupdate1", dependentInsurance);

        // setDependentjsonobj(Object.assign({}, dependentInsurance))

        // JSON.stringify(myArray)
      } else if (type == "additionInsurance") {
        setAdditionInsurance(update);
        console.log("indexupdate2", additionInsurance);

        // setadditionaljsonobj(Object.assign({}, additionInsurance))
      } else if (type == "basicDependent") {
        setBasicDependant(update);
        console.log("indexupdate3", basicDependent);
        //setIndex3(basicDependent)
      } else if (type == "basicContingentDependent") {
        setBasicDependantContingent(update);
      } else if (type == "additionContingentInsurance") {
        setAdditionInsuranceContingent(update);
      } else if (type == "dependentContingentInsurance") {
        setDependentInsuranceContingent(update);
      }
    }
    //basicDependent

    // setBasicDependant()
  };

  const handleChangeExpanded = (panel) => (event, isExpanded) => {
    setExpanded((prevState) => ({
      ...prevState,
      [panel]: isExpanded,
    }));
  };

  const getBenefitLifeInsurance = () => {
    setLoading(true)
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    const payload = {
      tableName: "sp_get_benefit_lifeInsurance_for_admin",
      SearchParams: `[{"columnName":"SubID","operator":"=","value":'${EmployeeId}',"dataType":"VARCHAR"}]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "ID DESC",
      sortBy: "",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: "",
    };
    axios
      .post(`${newBaseURL}/BenefitAdvanceSearch/Benefits-global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        let finalResponse = response.data.results[0];
        const finalSetValue = {
          id: finalResponse?.ID ? finalResponse?.ID : null,
          subscriberId: finalResponse?.SubscriberId,
          groupno: +finalResponse?.Groupno,
          classification: finalResponse?.Classification,
          EffectiveDate: finalResponse?.EffectiveDateEligibility,
          workHr: finalResponse?.WorkHours20,
          Life_Basic: finalResponse?.Life_Basic,
          // "lifeBasicAmount": 0,
          Life_Additional_Decline: finalResponse?.Life_Additional_Decline,
          Life_Additional_Accepted: finalResponse?.Life_Additional_Accepted,
          // "lifeAdditional": "string",
          Life_Additional_Amount: finalResponse?.Life_Additional_Amount,
          Life_Dependent_Decline: finalResponse?.Life_Dependent_Decline,
          Life_Dependent_Accepted: finalResponse?.Life_Dependent_Accepted,
          // "lifeDependentAmount": 0,
          // "employeeSign": finalResponse?.employeeSign,
          employeeSignDate: finalResponse?.EmployeeSignDate,
          agent_name: finalResponse?.AgentName,
          agent_date: finalResponse?.AgentDate
            ? moment(finalResponse?.AgentDate).format("YYYY-MM-DD")
            : null,
          Audit_date: finalResponse?.AuditDate
            ? moment(finalResponse?.AuditDate).format("YYYY-MM-DD")
            : null,
          Pay_period: +finalResponse?.PPE,
          Amount_deducted: finalResponse?.AmountDedecuted,
          lifeAdditionalBeneficiary: finalResponse?.lifeAdditionalBeneficiary
            ? JSON.parse(finalResponse?.lifeAdditionalBeneficiary)
            : [],
          lifeDependentBeneficiary: finalResponse?.lifeDependentBeneficiary
            ? JSON.parse(finalResponse?.lifeDependentBeneficiary)
            : [],
          basicBeneficiary: finalResponse?.basicBeneficiary
            ? JSON.parse(finalResponse?.basicBeneficiary)
            : [],
          lifeAdditionalContingent: finalResponse?.lifeAdditionalContingent
            ? JSON.parse(finalResponse?.lifeAdditionalContingent)
            : [],
          lifeDependentContingent: finalResponse?.lifeDependentContingent
            ? JSON.parse(finalResponse?.lifeDependentContingent)
            : [],
          basicContingent: finalResponse?.basicContingent
            ? JSON.parse(finalResponse?.basicContingent)
            : [],
          employeeSign: finalResponse?.EmployeeSign,
          Premiumrate: finalResponse?.PremiumRate,
          ...(finalResponse?.life_emp_name && { firstName: finalResponse.life_emp_name }),
          ...(finalResponse?.life_emp_ssn && { ssn: finalResponse.life_emp_ssn }),
          ...(finalResponse?.life_emp_gender && { gender: finalResponse.life_emp_gender }),
          ...(finalResponse?.life_emp_dob && { dob: finalResponse.life_emp_dob }),
          ...(finalResponse?.life_emp_email && { mailingAddress: finalResponse.life_emp_email }),
          ...(finalResponse?.life_emp_city && { city: finalResponse.life_emp_city }),
          ...(finalResponse?.life_emp_state && { state: finalResponse.life_emp_state }),
          ...(finalResponse?.life_emp_zip && { zip: finalResponse.life_emp_zip }),
          ...(finalResponse?.life_emp_job_title && { positionTitle: finalResponse.life_emp_job_title }),
          ...(finalResponse?.life_emp_phone && { homePhone: finalResponse.life_emp_phone }),
          ...(finalResponse?.life_emp_agen_phone && { deptName: finalResponse.life_emp_agen_phone }),
        };
        setDataObject(finalSetValue);
        setValues((state) => { return { ...state, ...finalSetValue } });
        setmainfinalSetValueid(finalSetValue.id);
        if (finalSetValue?.basicBeneficiary?.length) {
          setBasicDependant(finalSetValue?.basicBeneficiary);
        }
        if (finalSetValue?.lifeAdditionalBeneficiary?.length) {
          setAdditionInsurance(finalSetValue?.lifeAdditionalBeneficiary);
        }
        if (finalSetValue?.lifeDependentBeneficiary?.length) {
          setDependentInsurance(finalSetValue?.lifeDependentBeneficiary);
        }
        if (finalSetValue?.lifeAdditionalContingent?.length) {
          setAdditionInsuranceContingent(
            finalSetValue?.lifeAdditionalContingent
          );
        }
        if (finalSetValue?.lifeDependentContingent?.length) {
          setDependentInsuranceContingent(
            finalSetValue?.lifeDependentContingent
          );
        }
        if (finalSetValue?.basicContingent?.length) {
          setBasicDependantContingent(finalSetValue?.basicContingent);
        }
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      }).finally(() => {
        setLoading(false)
      })
  };

  const getDependentList = async (employeeId) => {
    try {
      setLoading(true)
      // const getDependent = await axios.get(
      //   `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/GetBySubscriberId?SubscriberId=${employeeId}`,
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
      //     },
      //   }
      // );
      const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
      const payload = {
        tableName: "sp_BenefitsDependent_v2",
        SearchParams: `[{"columnName":"EmpId","operator":"=","value":'${employeeId}',"dataType":"VARCHAR"}]`,
        columns: "*",
        pageNumber: 1,
        pageSize: 10000000,
        orderBy: "",
        sortBy: "Role desc",
        orderByMultiple: "",
        limit: 10000000000,
        sortData: "",
        additionalWhere: "",
      };

      const getNewData = await axios
        .post(`${newBaseURL}/BenefitAdvanceSearch/Benefits-global`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
            Role: getUserRole(userData),
          },
        })
      const getDependent = getNewData?.data?.results || []

      let resData = getDependent.find(
        (i) => i.Dependants == 'Self'
      );

      let searchData = {
        UID: resData?.UID,
        // id: resData?.id,
        employee_no: resData?.EmployeeID,
        subscriberId: resData?.SubscriberID,
        Employeetype: resData?.EmployeeType,
        HealthVendor: resData?.HealthVendor,
        healthPlan: resData?.HealthPlan,
        healthDeductionClass: resData?.healthDeductionClass,
        email: resData?.email,
        lastName: resData?.lastName,
        // mailingAddress: resData?.mailingAddress,
        // firstName: resData?.firstName,
        // dob: resData?.dob,
        // city: resData?.city,
        // zip: resData?.zip,
        // homePhone: resData?.homePhone,
        // state: resData?.state,
        // gender: resData?.gender,
        dateOfEmployment: resData?.DateOfEmployment
          ? moment(resData?.DateOfEmployment).format("YYYY-MM-DD")
          : null,
        // ssn: resData?.ssn,
        // diffYear: resData?.dateOfEmployment ? calculateYearDifference(resData.dateOfEmployment) : 0
      };
      setValues((state) => {
        return {
          ...state, ...searchData,
          ...(!state?.firstName && { firstName: resData?.FirstName }),
          ...(!state?.ssn && { ssn: resData?.SSN }),
          ...(!state?.gender && { gender: resData?.gender?.trim() == 'Male' ? 'Male' : resData?.gender?.trim() == 'Female' ? 'Female' : resData?.gender?.trim() == 'Other' ? 'Other' : '' }),
          ...(!state?.dob && { dob: resData?.DOB }),
          ...(!state?.mailingAddress && { mailingAddress: resData?.MailingAddress }),
          ...(!state?.city && { city: resData?.City }),
          ...(!state?.state && { state: resData?.State }),
          ...(!state?.zip && { zip: resData?.Zip }),
          // ...(!state?.positionTitle && { positionTitle: resData.life_emp_job_title }),
          ...(!state?.homePhone && { homePhone: resData?.HomePhone }),
          // ...(!state?.deptName && { deptName: resData.life_emp_agen_phone }),
        };
      });

      let MyDependents =
        getDependent.length > 1
          ? getDependent.filter((i) => i.Dependants == "Life Benenefit")
          : [];
      setDependentInformation(MyDependents[0]);
      setALLDependent(MyDependents);
      let dataInfo = [];
      MyDependents.map((l) => {
        dataInfo.push({
          value: l?.rowId,
          label: l?.FirstName,
        });
      });

      setPreDependent(dataInfo);
      setdeletedDependent([]);
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  };

  const handleBasicInsuranceDelete = (uid) => {
    setdeletedDependent([...deletedDependent, uid]);
  };

  const handleAdditionalInsuranceDelete = (uid) => {
    setdeletedDependent([...deletedDependent, uid]);
  };
  const handleDependentInsuranceDelete = (uid) => {
    setdeletedDependent([...deletedDependent, uid]);
  };

  useEffect(() => {
    getBenefitLifeInsurance();
  }, []);

  useEffect(() => {
    getDependentList(EmployeeId);
  }, [EmployeeId]);

  const renderCheckbox1 = (index, size = "large", stateName, value) => {
    return (
      <Checkbox
        size={size}
        checked={values[stateName] == value}
        onChange={(e) => {
          setValues({ ...values, [stateName]: value });
        }}
      />
    );
  };

  function renderTextInput(stateName, label, others = {}) {
    let other = {
      disabled: false,
      maxLength: "",
      multiline: false,
      shrink: true,
      ...others,
    };
    let {
      disabled,
      maxLength,
      multiline,
      required = false,
      shrink,
      type = "text",
    } = other;
    return (
      <TextField
        fullWidth
        size="small"
        inputProps={{
          style: {
            fontSize: "14px",
            paddingTop: "12px",
            width: "100%",
          },
          readOnly: disabled,
          maxLength: type === "number" ? null : maxLength,
          ...others,
        }}
        margin="dense"
        variant="outlined"
        label={label}
        name={stateName}
        id={stateName}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        value={values[stateName]}
        InputLabelProps={{
          shrink: shrink ? shrink : false,
          classes: { asterisk: required ? classes.asterisk : false },
        }}
        shrink={shrink ? "true" : "false"}
        onChange={(e) => {
          if (!disabled) {
            const { value } = e.target;
            if (type === "number" && maxLength && value.length > maxLength) {
              e.target.value = value.slice(0, maxLength); // Trim input to maxLength for number types
            }
            handleChange(e);
          }
        }}
        type={other.type || "text"} // Adding type here
        // onBlur={handleBlur}
        // error={!disabled && touched[stateName] && errors[stateName]}
        // helperText={
        //   !required && !disabled && touched[stateName] && errors[stateName]
        // }
        error={!disabled && errors[stateName]}
        // helperText={ !disabled && errors[ stateName ] }
        // placeholder={ !disabled && errors[ stateName ] }
        disabled={disabled}
        required={required}
      />
    );
  }

  function renderDateInput(
    stateName,
    label,
    disabled = false,
    minDate = null
    // maxDate
  ) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          inputVariant={"outlined"}
          margin="dense"
          format="MM/dd/yyyy"
          label={label}
          minDate={minDate}
          // maxDate={maxDate}
          value={values[stateName] ? values[stateName] : null}
          KeyboardButtonProps={{ "aria-label": label }}
          disabled={disabled}
          onChange={(value) => {
            const formatDate = value?.$d;
            const date = formatDate
              ? moment(formatDate).format("YYYY-MM-DD")
              : null;
            // setShow(false);
            console.log("Dasdasdsadaa", date);
            // setFieldValue(stateName, date);
            setValues({ ...values, [stateName]: date });
          }}
          // onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              fullWidth
              margin="dense"
              size="small"
              InputLabelProps={{ shrink: true }}
              {...params}
              error={!disabled && errors[stateName]}
            // helperText={!disabled && errors[stateName]}
            />
          )}
        />
      </LocalizationProvider>
    );
  }

  const getDateDifference = () => {
    const currentYear = moment().year();
    const defaultDate = moment(`09-30`, "MM-DD").year(currentYear);
    const currentDate = moment().year(currentYear);

    // Adjust the year for selectedDate if it is before constDate
    if (defaultDate.isBefore(currentDate)) {
      defaultDate.add(1, "year");
    }

    // Calculate the difference in days
    const diffDays = defaultDate.diff(currentDate, "days");

    return { diffDays, defaultDate, currentDate };
  };

  const verifyValidation = (values) => {
    let errors = {};
    if (!values.groupno) {
      errors.groupno = "Group No is required";
    }
    if (!values.firstName) {
      errors.firstName = "Employee Name is required";
    }
    if (!values.EffectiveDate) {
      errors.EffectiveDate = "Effective Date is required";
    }
    if (!values.homePhone) {
      errors.homePhone = "homePhone is required";
    }
    // if (!values.ssn) {
    //   errors.ssn = "SSN is required";
    // }
    // if (!values.DOB) {
    //   errors.DOB = "DOB is required";
    // }
    if (!values.gender) {
      errors.gender = "Gender is required";
    }

    console.log("dfdfdfdfdf", ![0, 1].includes(values.workHr));
    if (![0, 1].includes(values.workHr)) {
      errors.workHr = "work hour is required";
    }

    console.log("Email ", errors);

    return errors;
  };

  const handleSubmitData = (event) => {

    if (event) event.preventDefault();

    setErrors(verifyValidation(values));

    let hasError = false;

    if (
      !(
        values.Life_Basic ||
        values.Life_Additional_Decline ||
        values?.Life_Additional_Accepted ||
        values?.Life_Dependent_Decline ||
        values?.Life_Dependent_Accepted
      )
    ) {
      ShowError("at least 1 insurance select");
      hasError = true;
    }

    if (values.Life_Basic == "Y") {
      if (basicDependent?.length) {
        let ratioTotal = 0;
        basicDependent.forEach((i) => {
          ratioTotal += parseFloat(i.ratio);
        });
        if (ratioTotal !== 100) {
          ShowError("Basic insurance ratio should be 100");
          hasError = true;
        }
      }
    }

    if (
      values.Life_Additional_Decline == "Y" ||
      values.Life_Additional_Accepted == "Y"
    ) {
      if (additionInsurance?.length) {
        let ratioTotal = 0;
        additionInsurance.forEach((i) => {
          ratioTotal += parseFloat(i.ratio);
        });
        if (ratioTotal !== 100) {
          ShowError("Additional insurance ratio should be 100");
          hasError = true;
        }
      }
    }

    if (
      values.Life_Dependent_Accepted == "Y" ||
      values.Life_Dependent_Decline == "Y"
    ) {
      if (dependentInsurance?.length) {
        let ratioTotal = 0;
        dependentInsurance.forEach((i) => {
          ratioTotal += parseFloat(i.ratio);
        });
        if (ratioTotal !== 100) {
          ShowError("Dependent insurance ratio should be 100");
          hasError = true;
        }
      }
    }

    if (values.Life_Basic == "Y") {
      if (basicDependentContingent?.length) {
        let ratioTotal = 0;
        basicDependentContingent.forEach((i) => {
          ratioTotal += parseFloat(i.ratio);
        });
        if (ratioTotal !== 100) {
          ShowError("Basic Contingent insurance ratio should be 100");
          hasError = true;
        }
      }
    }

    if (
      values.Life_Additional_Decline == "Y" ||
      values.Life_Additional_Accepted == "Y"
    ) {
      if (additionInsuranceContingent?.length) {
        let ratioTotal = 0;
        additionInsuranceContingent.forEach((i) => {
          ratioTotal += parseFloat(i.ratio);
        });
        if (ratioTotal !== 100) {
          ShowError("Additional Contingent insurance ratio should be 100");
          hasError = true;
        }
      }
    }

    if (
      values.Life_Dependent_Accepted == "Y" ||
      values.Life_Dependent_Decline == "Y"
    ) {
      if (dependentInsuranceContingent?.length) {
        let ratioTotal = 0;
        dependentInsuranceContingent.forEach((i) => {
          ratioTotal += parseFloat(i.ratio);
        });
        if (ratioTotal !== 100) {
          ShowError("Dependent Contingent insurance ratio should be 100");
          hasError = true;
        }
      }
    }

    if (
      dataObject?.Life_Additional_Accepted == "Y" &&
      dataObject.Life_Additional_Amount &&
      values?.diffYear <= 5
    ) {
      let existPlanIndex = plan?.additional_amount?.findIndex(
        (i) => i.value == dataObject.Life_Additional_Amount
      );
      if (existPlanIndex !== -1) {
        let firstData = plan?.additional_amount[existPlanIndex + 1];
        let secondData = plan?.additional_amount[existPlanIndex + 2];
        let nextTwoSelectable = [firstData?.value, secondData?.value];
        const filteredArray = nextTwoSelectable.filter(
          (item) => item !== null && item !== undefined
        );
        let finalArray = plan.additional_amount
          .filter((item) => item.value <= dataObject.Life_Additional_Amount)
          .map((item) => item.value);
        let checkableArray = [...finalArray, ...filteredArray];
        console.log("ADasddadasad", checkableArray);

        if (!checkableArray.includes(values?.Life_Additional_Amount)) {
          ShowError(
            `You can increase upto $${secondData?.value
              ? secondData?.value
              : firstData?.value
                ? firstData?.value
                : dataObject.Life_Additional_Amount
            } only!`
          );
          hasError = true;
        }
      }
    }

    if (
      hasError ||
      !values.groupno ||
      !values.firstName ||
      !values.homePhone ||
      !values.EffectiveDate
    ) {
      return;
    }

    setLoading(true)

    let payload = {
      subscriberId: values.employee_no,
      groupno: +values.groupno,
      classification: values.classification,
      effectiveDateEligibility: values.EffectiveDate,
      workHours20: values.workHr,
      lifeBasic: values.Life_Basic,
      // "lifeBasicAmount": 0,
      lifeAdditionalDecline:
        values.Life_Additional_Accepted == "Y"
          ? ""
          : values.Life_Additional_Decline,
      lifeAdditionalAccepted:
        values.Life_Additional_Decline == "Y"
          ? ""
          : values.Life_Additional_Accepted,
      // "lifeAdditional": "string",
      lifeAdditionalAmount:
        values.Life_Additional_Decline == "Y"
          ? 0
          : values.Life_Additional_Amount,
      lifeDependentDecline:
        values.Life_Dependent_Accepted == "Y"
          ? ""
          : values.Life_Dependent_Decline,
      lifeDependentAccepted:
        values.Life_Dependent_Decline == "Y"
          ? ""
          : values.Life_Dependent_Accepted,
      lifeDependentAmount: plan.dependents_amount,
      // "employeeSign": values.employeeSign,
      employeeSignDate: values.employeeSignDate,
      agentName: values.agent_name,
      agentDate: values.agent_date,
      auditDate: values.Audit_date,
      ppe: +values.Pay_period,
      amountDedecuted: values.Amount_deducted,
      "premiumRate": values.Premiumrate,
      basicBeneficiary: JSON.stringify(
        removeKeyFromObjects(basicDependent, "isSSN")
      ),
      lifeAdditionalBeneficiary: JSON.stringify(
        removeKeyFromObjects(additionInsurance, "isSSN")
      ),
      lifeDependentBeneficiary: JSON.stringify(
        removeKeyFromObjects(dependentInsurance, "isSSN")
      ),
      basicContingent: JSON.stringify(
        removeKeyFromObjects(basicDependentContingent, "isSSN")
      ),
      lifeAdditionalContingent: JSON.stringify(
        removeKeyFromObjects(additionInsuranceContingent, "isSSN")
      ),
      lifeDependentContingent: JSON.stringify(
        removeKeyFromObjects(dependentInsuranceContingent, "isSSN")
      ),
      employeeSign: values?.employeeSign,
      lifeEmpName: values?.firstName,
      lifeEmpSsn: values?.ssn,
      lifeEmpGender: values?.gender,
      lifeEmpDob: values?.dob,
      lifeEmpEmail: values?.mailingAddress,
      lifeEmpCity: values?.city,
      lifeEmpState: values?.state,
      lifeEmpZip: values?.zip,
      lifeEmpJobTitle: values?.positionTitle,
      lifeEmpPhone: values?.homePhone,
      lifeEmpAgenPhone: values?.deptName,
    };

    let createAPI = `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsLifeInsurance/create`;

    if (values.id) {
      let UpdateAPI = `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsLifeInsurance/update`;
      payload = { ...payload, id: mainfinalSetValueid };
      axios
        .put(UpdateAPI, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        })
        .then((res) => {
          ShowSucess(res.data);
          getBenefitLifeInsurance();
        })
        .catch((err) => {
        }).finally(() => {
          setLoading(false)
        })
    } else {
      axios
        .post(createAPI, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        })
        .then((res) => {
          console.log("updatecoverage", res);
          ShowSucess(res.data);
          getBenefitLifeInsurance();
        })
        .catch((err) => {
          console.log("updatecoverage", err);
        }).finally(() => {
          setLoading(false)
        })
    }
  };
  const handelValidateAdditional = (index, amount, newAmount) => {
    let oldIndex = plan?.additional_amount.findIndex((k) => k.value == amount);
    console.log(oldIndex, "$$$", plan?.additional_amount?.length);

    if (oldIndex !== -1) {
      if (oldIndex + 1 == plan?.additional_amount?.length) {
        return true;
      }
      let firstData = plan?.additional_amount[oldIndex + 1];
      let secondData = plan?.additional_amount[oldIndex + 2];

      let status = true;
      if (values?.diffYear <= 5) {
        if (
          [amount, firstData.value, secondData.value].includes(newAmount) ||
          newAmount < amount
        ) {
        } else {
          ShowError(
            `You can increase upto $${secondData?.value
              ? secondData?.value
              : firstData?.value
                ? firstData?.value
                : dataObject.Life_Additional_Amount
            } only!`
          );
          status = false;
        }
      }
      return status;

    } else {
      return true;
    }
  };

  const handleChange = (event) => {
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };


  return (
    <Fragment>
      {loding && loadingPanel()}
      <Container fluid={true} className="updView">
        <Row className="bg-primary rounded m-0 p-0 py-1 mb-3 ">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5">
              <Icon style={{ fontSize: "25px", margin: "10px" }} name="graph" />
              Standard Insurance Company
            </Typography>
            <div style={{ alignSelf: "center" }}>
              {/* <span
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  margin: "0px 5px",
                }}
              >
                {" "}
                {getDateDifference()?.diffDays} Days
              </span>
              Until Open Enrollment Ends on
              <span
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  margin: "0px 5px",
                }}
              >
                {" "}
                {moment(getDateDifference()?.defaultDate).format("MMM DD,YYYY")}
              </span> */}
            </div>
          </div>
        </Row>
        {/* submit button */}
        <Card
          style={{
            marginTop: "10px",
            padding: "10px",
          }}
        >
          <div>

            {moment(values.dateOfEmployment).format("YYYY-MM-DD") <
              moment().subtract(6, "month").format("YYYY-MM-DD") ? (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "end",
                }}
              >
                {moment(values.dateOfEmployment).format("YYYY-MM-DD") <
                  moment().subtract(7, "month").format("YYYY-MM-DD") ? (
                  <Button
                    onClick={(e) => navigate(`/coverage-medical/${EmployeeId}`)}
                    style={{ color: "white", marginRight: "10px" }}
                    variant="fill"
                    className="btn btn-warning mr-2"
                    color="warning"
                  >
                    Medical Assessment Required
                  </Button>
                ) : null}
                {moment(values?.dateOfEmployment).format("YYYY-MM-DD") <
                  moment().subtract(6, "month").format("YYYY-MM-DD") ? (
                  <Button
                    onClick={(e) => handleSubmitData()}
                    style={{ color: "white" }}
                    variant="fill"
                    className="btn btn-primary ml-2"
                  >
                    Update Coverage
                  </Button>
                ) : null}
              </div>
            ) : (
              <>
                {!loding && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      width: "100%",
                    }}
                  >
                    <Alert severity="error" style={{ width: "100%" }}>
                      You can add coverage after six months of joining, Your six
                      months will be completed on{" "}
                      {moment(values?.dateOfEmployment)
                        .add(6, "month")
                        .format("MM/DD/YYYY")}
                    </Alert>
                  </div>
                )}
              </>
            )}
          </div>
          {/* <div>
          <Alert severity="error">This is an error Alert.</Alert>
        </div> */}
        </Card>
        {/* HR details */}
        {/* Error text */}
        {/* End Error text */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.empDetail}
            onChange={handleChangeExpanded("empDetail")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                To Be Completed By Human Resources
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Row>
                  <Col md={4}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("groupno", `Group No`, {
                        required: true,
                        type: "number",
                        maxLength: 10,
                      })}
                    </div>
                    <Errorlable text={errors.groupno} />
                  </Col>
                  <Col md={4}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("firstName", "Employee Name", {
                        required: true,
                      })}
                    </div>
                    <Errorlable text={errors.firstName} />
                  </Col>
                  <Col md={4}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderTextInput("classification", "Classification")}
                    </div>
                    <Errorlable text={errors.classification} />
                  </Col>
                  <Col md={4}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderDateInput(
                        "dateOfEmployment",
                        "Date of Employment",
                        true
                      )}
                    </div>
                  </Col>
                  <Col md={4}>
                    <div style={{ marginBlockEnd: "-4px" }}>
                      {renderDateInput(
                        "EffectiveDate",
                        "Effective Date of Eligibility"
                      )}
                    </div>
                    <Errorlable text={errors.EffectiveDate} />
                  </Col>
                </Row>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* End of HR details */}
        {/* User details */}
        <Card style={{ marginTop: "10px" }}>
          <Accordion
            className={classes.root}
            expanded={expanded.empDetail}
            onChange={handleChangeExpanded("empDetail")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2bh-content"
              id="panel2bh-header"
              className="sub-header w-100 p-1 bg-primary text-white"
              style={{ width: "100%" }}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                className="sub-header"
                style={{
                  // color: "#1569C7",
                  marginRight: "10px",
                  marginTop: "3px",
                }}
              />
              <Typography
                className={classes.heading}
                style={{ height: "auto" }}
              >
                Applicant Info
              </Typography>
            </AccordionSummary>
            <AccordionDetails className="p-0 page-body-wrapper">
              <Card style={{ padding: "20px" }}>
                <Row>
                  <Col md={3}>
                    {renderTextInput("firstName", "Employee Name", {
                      required: true,
                    })}
                    <Errorlable text={errors.firstName} />
                  </Col>
                  <Col md={3}>
                    {renderTextInput("ssn", "Last 4 SSN", { maxLength: 4 })}
                    <Errorlable text={errors.ssn} />
                  </Col>
                  <Col md={2}>
                    {renderDateInput("dob", "DOB")}
                    <Errorlable text={errors.DOB} />
                  </Col>

                  <Col md={4}>
                    <div>
                      {plan.Zender.map((i) => {
                        return (
                          <span
                            style={{ display: "inline-block" }}
                            key={i.value}
                          >
                            <Checkbox
                              size={"medium"}
                              value={values?.gender ? values?.gender : null}
                              checked={values?.gender === i.value}
                              onChange={() =>
                                setValues({ ...values, gender: i.value })
                              }
                            />
                            {i.label}
                          </span>
                        );
                      })}
                    </div>
                    <Errorlable text={errors.gender} />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    {renderTextInput("mailingAddress", "Mailing Address")}
                    <Errorlable text={errors.mailingAddress} />
                  </Col>
                  <Col md={2}>{renderTextInput("city", "City")}</Col>
                  <Col md={2}>
                    {renderTextInput("state", "State/Territory")}
                  </Col>
                  <Col md={2}>{renderTextInput("zip", "Zip")}</Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div style={{ display: "flex" }}>
                      <span style={{ marginTop: "10px" }}>
                        Do you work 20 hours or more?
                      </span>
                      <span>
                        {renderCheckbox1(0, "medium", "workHr", "1")} Yes
                      </span>
                      <span>
                        {renderCheckbox1(0, "medium", "workHr", "0")} No
                      </span>
                    </div>
                    <Errorlable text={errors.workHr} />
                  </Col>
                  <Col md={2}>
                    {renderTextInput("positionTitle", "Job Title/Occupation")}
                  </Col>
                  <Col md={2}>
                    {renderTextInput("homePhone", "Phone Number", {
                      required: true,
                      type: "number",
                      maxLength: 12,
                    })}
                    <Errorlable text={errors.homePhone} />
                  </Col>
                  <Col md={2}>
                    {renderTextInput("deptName", "Agency/Department Number")}
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <div style={{ display: "flex" }}>
                      <span style={{ marginTop: "10px", fontWeight: "bold" }}>
                        Coverage Check with your Human Resources Department
                        about coverage options available to you and Evidence Of
                        Insurability requirements.
                      </span>
                    </div>
                  </Col>
                  <Col md={12}>
                    <div style={{ display: "flex" }}>
                      <span style={{ padding: "10px 0px" }}>
                        <b>{plan.basic_plan}</b>
                        <Checkbox
                          size={"medium"}
                          checked={values["Life_Basic"] == "Y"}
                          onChange={(e) => {
                            setValues({
                              ...values,
                              Life_Basic: e.target.checked ? "Y" : null,
                            });
                          }}
                        />
                        {plan.basic_description}{" "}
                        {values.Life_Basic == "Y" ? (
                          <>
                            <a
                              href="#basicinsurance"
                              style={{
                                fontSize: "9px",
                                fontWeight: "bold",
                                borderBottom: "1px solid",
                                fontStyle: "italic",
                              }}
                              onClick={(e) =>
                                scrollToSection(e, "basicinsurance")
                              }
                            >
                              Goto Beneficiary
                            </a>
                            <ArrowDownwardIcon
                              style={{
                                fontSize: "14px",
                                marginBottom: "-5px",
                                marginLeft: "4px",
                                color: "var(--theme-default)",
                                cursor: "pointer",
                              }}
                              onClick={(e) =>
                                scrollToSection(e, "basicinsurance")
                              }
                            />
                          </>
                        ) : null}
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <div style={{ display: "flex" }}>
                      <span style={{ padding: "10px 0px" }}>
                        <b>{plan.additional_plan}</b>
                      </span>{" "}
                      <Checkbox
                        size={"medium"}
                        checked={values["Life_Additional_Decline"] == "Y"}
                        onChange={(e) => {
                          setValues({
                            ...values,
                            Life_Additional_Decline: e.target.checked
                              ? "Y"
                              : null,
                            Life_Additional_Accepted: e.target.checked
                              ? null
                              : "Y",
                            Life_Additional_Amount: e.target.checked
                              ? values?.lifeAdditionalAmount == "Y" &&
                              values.Life_Additional_Amount
                              : dataObject.Life_Additional_Amount
                                ? dataObject?.Life_Additional_Amount
                                : null,
                          });
                        }}
                      />
                      <span style={{ padding: "10px 0px" }}>
                        {plan.additional_plan_decline}{" "}
                        {values.Life_Additional_Decline == "Y" ||
                          values.Life_Additional_Accepted == "Y" ? (
                          <>
                            <a
                              href="#additionalinsurance"
                              style={{
                                fontSize: "9px",
                                fontWeight: "bold",
                                borderBottom: "1px solid",
                                fontStyle: "italic",
                              }}
                              onClick={(e) =>
                                scrollToSection(e, "additionalinsurance")
                              }
                            >
                              Goto Beneficiary
                            </a>
                            <ArrowDownwardIcon
                              style={{
                                fontSize: "14px",
                                marginBottom: "-5px",
                                marginLeft: "4px",
                                color: "var(--theme-default)",
                                cursor: "pointer",
                              }}
                              onClick={(e) =>
                                scrollToSection(e, "additionalinsurance")
                              }
                            />
                          </>
                        ) : null}
                      </span>
                    </div>
                    <div style={{ padding: "10px 0px" }}>
                      {plan.additional_line1}
                    </div>

                    <div style={{ display: "flex" }}>
                      <div>
                        <span>
                          <Checkbox
                            size={"medium"}
                            checked={values["Life_Additional_Accepted"] == "Y"}
                            onChange={(e) => {
                              setValues({
                                ...values,
                                Life_Additional_Accepted: e.target.checked
                                  ? "Y"
                                  : null,
                                Life_Additional_Decline: e.target.checked
                                  ? null
                                  : "Y",
                                Life_Additional_Amount: e.target.checked
                                  ? dataObject?.Life_Additional_Amount
                                  : null,
                              });
                            }}
                          />
                          {plan.additional_select}
                        </span>
                      </div>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div>
                        {plan.additional_amount.map((i, index) => {
                          return (
                            <span
                              style={{ display: "inline-block" }}
                              key={i.value}
                            >
                              <Checkbox
                                size={"medium"}
                                value={i.value}
                                checked={
                                  values["Life_Additional_Amount"] == i.value
                                }
                                onChange={() => {
                                  if (
                                    handelValidateAdditional(
                                      index,
                                      dataObject.Life_Additional_Amount,
                                      i.value
                                    )
                                  ) {
                                    setValues({
                                      ...values,
                                      Life_Additional_Amount: i.value,
                                      Life_Additional_Accepted: "Y",
                                      Life_Additional_Decline: null,
                                    });
                                  }
                                }}
                              />
                              {i.label}
                            </span>
                          );
                        })}
                      </div>
                      <div></div>
                    </div>

                    <div style={{ display: "flex" }}>
                      <span style={{ padding: "10px 0px" }}>
                        <b>{plan.dependents_plan}</b>
                      </span>{" "}
                      <Checkbox
                        size={"medium"}
                        checked={values["Life_Dependent_Decline"] === "Y"}
                        onChange={(e) => {
                          setValues({
                            ...values,
                            Life_Dependent_Decline: e.target.checked
                              ? "Y"
                              : null,
                            Life_Dependent_Accepted: null,
                          });
                        }}
                      />
                      <span style={{ padding: "10px 0px" }}>
                        {plan.dependents_decline}{" "}
                        {values.Life_Dependent_Accepted == "Y" ||
                          values.Life_Dependent_Decline == "Y" ? (
                          <>
                            {" "}
                            <a
                              href="#dependentinsurance"
                              style={{
                                fontSize: "9px",
                                fontWeight: "bold",
                                borderBottom: "1px solid",
                                fontStyle: "italic",
                              }}
                              onClick={(e) =>
                                scrollToSection(e, "dependentinsurance")
                              }
                            >
                              Goto Beneficiary
                            </a>
                            <ArrowDownwardIcon
                              style={{
                                fontSize: "14px",
                                marginBottom: "-5px",
                                marginLeft: "4px",
                                color: "var(--theme-default)",
                                cursor: "pointer",
                              }}
                              onClick={(e) =>
                                scrollToSection(e, "dependentinsurance")
                              }
                            />
                          </>
                        ) : null}
                      </span>
                    </div>
                    <div style={{ display: "flex" }}>
                      <Checkbox
                        size={"medium"}
                        checked={values["Life_Dependent_Accepted"] === "Y"}
                        onChange={(e) => {
                          setValues({
                            ...values,
                            Life_Dependent_Accepted: e.target.checked
                              ? "Y"
                              : null,
                            Life_Dependent_Decline: null,
                          });
                        }}
                      />
                      <span style={{ padding: "10px 0px" }}>
                        {plan.dependents_description}
                      </span>
                    </div>
                    <Errorlable text={errors.insuranceCommon} />
                  </Col>
                  <hr></hr>
                  {values.Life_Basic === "Y" ||
                    values.Life_Additional_Decline === "Y" ||
                    values.Life_Additional_Accepted === "Y" ||
                    values.Life_Dependent_Accepted === "Y" ||
                    values.Life_Dependent_Decline === "Y" ? (
                    <Col md={5}>
                      <Button
                        style={{ color: "white" }}
                        variant="fill"
                        className="btn btn-primary ml-2"
                      >
                        Add dependent
                      </Button>
                    </Col>
                  ) : null}
                  <Col id="basicinsurance">
                    {values?.Life_Basic == "Y" && basicDependent.length > 0 ? (
                      <Card style={{ marginTop: "10px" }}>
                        <Accordion
                          className={classes.root}
                          expanded={expanded.dependent}
                          onChange={handleChangeExpanded("dependent")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                            className="sub-header w-100 p-1 bg-primary text-white"
                            style={{ width: "100%" }}
                          >
                            <FontAwesomeIcon
                              icon={faRectangleList}
                              className="sub-header"
                              style={{
                                // color: "#1569C7",
                                marginRight: "10px",
                                marginTop: "3px",
                              }}
                            />
                            <Typography
                              className={classes.heading}
                              style={{ height: "auto" }}
                            >
                              Basic Insurance Beneficiary Information
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="p-0 page-body-wrapper">
                            <Depedentinformation
                              dependentInformation={
                                basicDependent?.length
                                  ? basicDependent
                                  : basicInsurance
                              }
                              preDependent={preDependent}
                              handlePrefill={handlePrefill}
                              type={"basicDependent"}
                              setDependentInformation={setBasicDependant}
                              Insurance={"Beneficiary"}
                              initialDependent={{
                                ...basicInsurance,
                                lastName: dependentInformation?.lastName,
                              }}
                              // handleDependentUpdate={handleDependentUpdate}
                              handleDependentDelete={handleBasicInsuranceDelete}
                              // setClassValues={setClassValues}
                              // values={values?.healthDeductionClass}
                              btnhide={true}
                            />
                          </AccordionDetails>
                        </Accordion>
                      </Card>
                    ) : null}
                  </Col>

                  <Col>
                    {values?.Life_Basic == "Y" && basicDependent.length > 0 ? (
                      <Card style={{ marginTop: "10px" }}>
                        <Accordion
                          className={classes.root}
                          expanded={expanded.dependent}
                          onChange={handleChangeExpanded("dependent")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                            className="sub-header w-100 p-1   text-white"
                            style={{
                              width: "100%",
                              backgroundColor: "#a97ec6",
                              color: "#fff",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faRectangleList}
                              className="sub-header"
                              style={{
                                // color: "#1569C7",
                                marginRight: "10px",
                                marginTop: "3px",
                              }}
                            />
                            <Typography
                              className={classes.heading}
                              style={{ height: "auto" }}
                            >
                              Basic Insurance Contingent Information
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="p-0 page-body-wrapper">
                            <Depedentinformation
                              dependentInformation={basicDependentContingent}
                              preDependent={preDependent}
                              handlePrefill={handlePrefill}
                              type={"basicContingentDependent"}
                              Insurance={"Contingent"}
                              setDependentInformation={
                                setBasicDependantContingent
                              }
                              initialDependent={{
                                ...basicContingentInsurance,
                                lastName: dependentInformation?.lastName,
                              }}
                              // handleDependentUpdate={handleDependentUpdate}
                              handleDependentDelete={handleBasicInsuranceDelete}
                              // setClassValues={setClassValues}
                              // values={values?.healthDeductionClass}
                              btnhide={true}
                            />
                          </AccordionDetails>
                        </Accordion>
                      </Card>
                    ) : null}
                  </Col>

                  <Col id="additionalinsurance">
                    {(values?.Life_Additional_Decline == "Y" ||
                      values?.Life_Additional_Accepted == "Y") &&
                      basicDependent.length > 0 ? (
                      <Card style={{ marginTop: "10px" }}>
                        <Accordion
                          className={classes.root}
                          expanded={expanded.dependent}
                          onChange={handleChangeExpanded("dependent")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                            className="sub-header w-100 p-1 bg-primary text-white"
                            style={{ width: "100%" }}
                          >
                            <FontAwesomeIcon
                              icon={faRectangleList}
                              className="sub-header"
                              style={{
                                // color: "#1569C7",
                                marginRight: "10px",
                                marginTop: "3px",
                              }}
                            />
                            <Typography
                              className={classes.heading}
                              style={{ height: "auto" }}
                            >
                              Additional Insurance Beneficiary Information
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="p-0 page-body-wrapper">
                            <Depedentinformation
                              dependentInformation={additionInsurance}
                              // preDependent={preDependent}
                              preDependent={preDependent}
                              // preDependent= {preDependent.filter(dept => !additionInsurance.map(item1 => item1.id).includes(dept.value))}
                              handlePrefill={handlePrefill}
                              type={"additionInsurance"}
                              setDependentInformation={setAdditionInsurance}
                              Insurance={"Beneficiary"}
                              initialDependent={{
                                ...optionalInsurance,
                                lastName: dependentInformation?.lastName,
                              }}
                              // handleDependentUpdate={handleDependentUpdate}
                              handleDependentDelete={
                                handleAdditionalInsuranceDelete
                              }
                              // setClassValues={setClassValues}
                              // values={values?.healthDeductionClass}
                              btnhide={true}
                            />
                          </AccordionDetails>
                        </Accordion>
                      </Card>
                    ) : null}
                  </Col>

                  <Col>
                    {(values?.Life_Additional_Decline == "Y" ||
                      values?.Life_Additional_Accepted == "Y") &&
                      basicDependent.length > 0 ? (
                      <Card style={{ marginTop: "10px" }}>
                        <Accordion
                          className={classes.root}
                          expanded={expanded.dependent}
                          onChange={handleChangeExpanded("dependent")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                            className="sub-header w-100 p-1  text-white"
                            style={{
                              width: "100%",
                              backgroundColor: "#a97ec6",
                              color: "#fff",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faRectangleList}
                              className="sub-header"
                              style={{
                                // color: "#1569C7",
                                marginRight: "10px",
                                marginTop: "3px",
                              }}
                            />
                            <Typography
                              className={classes.heading}
                              style={{ height: "auto" }}
                            >
                              Additional Insurance Contingent Information
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="p-0 page-body-wrapper">
                            <Depedentinformation
                              dependentInformation={additionInsuranceContingent}
                              // preDependent={preDependent}
                              preDependent={preDependent}
                              // preDependent= {preDependent.filter(dept => !additionInsurance.map(item1 => item1.id).includes(dept.value))}
                              handlePrefill={handlePrefill}
                              type={"additionContingentInsurance"}
                              setDependentInformation={
                                setAdditionInsuranceContingent
                              }
                              initialDependent={{
                                ...optionaloContingentInsurance,
                                lastName: dependentInformation?.lastName,
                              }}
                              Insurance={"Contingent"}
                              // handleDependentUpdate={handleDependentUpdate}
                              handleDependentDelete={
                                handleAdditionalInsuranceDelete
                              }
                              // setClassValues={setClassValues}
                              // values={values?.healthDeductionClass}
                              btnhide={true}
                            />
                          </AccordionDetails>
                        </Accordion>
                      </Card>
                    ) : null}
                  </Col>

                  <Col id="dependentinsurance">
                    {(values?.Life_Dependent_Decline == "Y" ||
                      values?.Life_Dependent_Accepted == "Y") &&
                      basicDependent.length > 0 ? (
                      <Card style={{ marginTop: "10px" }}>
                        <Accordion
                          className={classes.root}
                          expanded={expanded.dependent}
                          onChange={handleChangeExpanded("dependent")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                            className="sub-header w-100 p-1 bg-primary text-white"
                            style={{ width: "100%" }}
                          >
                            <FontAwesomeIcon
                              icon={faRectangleList}
                              className="sub-header"
                              style={{
                                // color: "#1569C7",
                                marginRight: "10px",
                                marginTop: "3px",
                              }}
                            />
                            <Typography
                              className={classes.heading}
                              style={{ height: "auto" }}
                            >
                              Dependent Insurance Beneficiary Information
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="p-0 page-body-wrapper">
                            <Depedentinformation
                              dependentInformation={dependentInsurance}
                              preDependent={preDependent} //?.filter((i) => !ind1?.includes(i.value))}
                              handlePrefill={handlePrefill}
                              type={"dependentInsurance"}
                              setDependentInformation={setDependentInsurance}
                              initialDependent={{
                                ...dependInsurance,
                                lastName: dependentInformation?.lastName,
                              }}
                              Insurance={"Beneficiary"}
                              // handleDependentUpdate={handleDependentUpdate}
                              handleDependentDelete={
                                handleDependentInsuranceDelete
                              }
                              // setClassValues={setClassValues}
                              // values={values?.healthDeductionClass}
                              btnhide={true}
                            />
                          </AccordionDetails>
                        </Accordion>
                      </Card>
                    ) : null}
                  </Col>

                  <Col>
                    {(values?.Life_Dependent_Decline == "Y" ||
                      values?.Life_Dependent_Accepted == "Y") &&
                      basicDependent.length > 0 ? (
                      <Card style={{ marginTop: "10px" }}>
                        <Accordion
                          className={classes.root}
                          expanded={expanded.dependent}
                          onChange={handleChangeExpanded("dependent")}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                            className="sub-header w-100 p-1   text-white"
                            style={{
                              width: "100%",
                              backgroundColor: "#a97ec6",
                              color: "#fff",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faRectangleList}
                              className="sub-header"
                              style={{
                                // color: "#1569C7",
                                marginRight: "10px",
                                marginTop: "3px",
                              }}
                            />
                            <Typography
                              className={classes.heading}
                              style={{ height: "auto" }}
                            >
                              Dependent Insurance Contingent Information
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className="p-0 page-body-wrapper">
                            <Depedentinformation
                              dependentInformation={
                                dependentInsuranceContingent
                              }
                              preDependent={preDependent} //?.filter((i) => !ind1?.includes(i.value))}
                              handlePrefill={handlePrefill}
                              type={"dependentContingentInsurance"}
                              setDependentInformation={
                                setDependentInsuranceContingent
                              }
                              Insurance={"Contingent"}
                              initialDependent={{
                                ...dependContingentInsurance,
                                lastName: dependentInformation?.lastName,
                              }}
                              // handleDependentUpdate={handleDependentUpdate}
                              handleDependentDelete={
                                handleDependentInsuranceDelete
                              }
                              // setClassValues={setClassValues}
                              // values={values?.healthDeductionClass}
                              btnhide={true}
                            />
                          </AccordionDetails>
                        </Accordion>
                      </Card>
                    ) : null}
                  </Col>

                  <Col lg={12}>
                    <p
                      style={{
                        fontSize: "12px",
                        marginTop: "12px",
                        fontStyle: "italic",
                        fontWeight: "400",
                      }}
                    >
                      Beneficiary This designation applies to Basic Life with
                      AD&D or Additional Life Insurance available through your
                      Employer, if any. Separate beneficiaries may be selected
                      for each coverage. Check the appropriate box below for
                      each beneficiary. If a minor (a person not of legal age)
                      is a beneficiary, please include the name, address and
                      phone number of the minor’s guardian, if any. Designations
                      are not valid unless signed, dated, and delivered to the
                      Employer during your lifetime. See page 2 for further
                      information. Life Plan Primary - Full Name Mailing Address
                      Phone Number Soc. Sec. No./DOB Relationship % of Benefit*
                    </p>
                  </Col>

                  <div style={{ marginTop: "12px" }}>
                    <div>
                      <p style={{ fontSize: "12px" }}>
                        <b>Signature </b>I wish to make the choices indicated on
                        this form. If electing coverage, I authorize deductions
                        from my wages to cover my contribution, if required,
                        toward the cost of insurance. I understand that my
                        deduction amount will change if my coverage or costs
                        change. If declining coverage, I understand that if I
                        want to become insured later, I will be required to
                        provide The Standard with satisfactory Evidence of
                        Insurability, and that The Standard will have the right
                        to refuse my request for insurance. I understand that
                        coverage(s) not specifically elected will not become
                        effective, even if not marked as declined above.
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        marginTop: "13px",
                        flexWrap: "wrap",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <b style={{ fontSize: "14px", marginRight: "5px" }}>
                          Member/Employee Signature Required
                        </b>
                        {/* <input type="text" id="text" style={{borderLeft:"none",marginLeft:"5px",borderRight:"none",borderTop:"none"}}></input> */}
                        {/* <Col md={5}>{renderTextInput("employeeSign", "")}</Col> */}
                        <Col md={5}>
                          <div
                            style={{
                              background: "white",
                              border: "1px solid lightgray",
                              width: "100%",
                              marginTop: "6px",
                              height: "100px",
                              borderRadius: "5px",
                              padding: "5px"
                            }}
                          >
                            <small
                              style={
                                !true
                                  ? {
                                    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                                    fontSize: "15px",
                                    top: "2px",
                                    color: "rgba(0, 0, 0, 0.38)",
                                    position: "sticky",
                                    display: "block",
                                    padding: "3px 6px",
                                  }
                                  : {
                                    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
                                    fontSize: "15px",
                                    top: "2px",
                                    color: "rgba(0, 0, 0, 0.6)",
                                    position: "sticky",
                                    display: "block",
                                    padding: "3px 6px",
                                  }
                              }
                            >
                              {"Member/Employee Signature Required"}
                            </small>
                            {values?.employeeSign ? (
                              <img className={"sigImage"}
                                // src={removeAfterString(getValues(signature)?.trim(), '=sv')?.status ? removeAfterString(getValues(signature)?.trim(), 'sv=')?.newUrl : getValues(signature)?.trim()} 
                                src={values?.employeeSign}
                              />
                            ) : null}
                            <button
                              className="icon m-2 "
                              style={{
                                border: "none",
                                backgroundColor: "transparent",
                              }}
                              type="button"
                              onClick={(e) => {
                                setOpenCanvas(true);
                                // setStateOfSign(stateName);
                              }}
                            >
                              {true == false ? (
                                <FontAwesomeIcon
                                  icon={faUpload}
                                  size="lg"
                                  style={{
                                    "--fa-primary-color": "#919191",
                                    "--fa-secondary-color": "#bababa",
                                  }}
                                />
                              ) : (
                                <i class="fa-duotone fa-upload  fa-lg"></i>
                              )}
                            </button>
                          </div>
                        </Col>
                      </div>
                      <div style={{ width: "50%", paddingLeft: "5px" }}>
                        <b style={{ fontSize: "14px", marginRight: "5px" }}>
                          Signature Date
                        </b>


                        {/* <input type="text" id="text" style={{borderLeft:"none",marginLeft:"5px",borderRight:"none",borderTop:"none"}}></input> */}
                        <Col md={5}>
                          {renderDateInput("employeeSignDate", "")}
                        </Col>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        marginTop: "14px",
                        marginBottom: "12px",
                        flexWrap: "wrap",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <div>
                          <b>EMPLOYER USE ONLY</b>
                        </div>
                        <div style={{ marginTop: "6px" }}>
                          <Row>
                            <Col md={5}>
                              {renderTextInput(
                                "agent_name",
                                "Validated GovGuam/The Standard Agent Name"
                              )}
                            </Col>
                            <Col md={4}>
                              {renderDateInput("agent_date", "Date")}
                            </Col>
                          </Row>
                        </div>
                      </div>
                      <div style={{ width: "50%", paddingLeft: "5px" }}>
                        <div>
                          <b>AUDIT PURPOSE ONLY</b>
                        </div>
                        <div style={{ marginTop: "6px" }}>
                          <Row>
                            <Col md={4}>
                              {renderDateInput("Audit_date", "Audit Date")}
                            </Col>
                            <Col md={4}>
                              {renderTextInput("Pay_period", "Pay Period")}
                            </Col>
                            <Col md={4}>
                              {renderTextInput(
                                "Amount_deducted",
                                "Amount Deducted"
                              )}
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div>
                      <b>Premium Rate </b>
                      <span>
                        {renderCheckbox1(
                          0,
                          "medium",
                          "Premiumrate",
                          1
                        )}{" "}
                        Composite Rate
                      </span>
                      <span>
                        {renderCheckbox1(
                          0,
                          "medium",
                          "Premiumrate",
                          2
                        )}{" "}
                        Age-Banded Rate
                      </span>
                    </div>
                  </div>

                  <Col>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: "12px",
                        marginBottom: "10px",
                      }}
                    >
                      <b style={{ fontWeight: "bold", margin: "0px" }}>
                        Beneficiary Information
                      </b>
                    </div>
                    <div>
                      <ul
                        style={{
                          listStyleType: "disc",
                          marginLeft: "12px",
                          marginBottom: "10px",
                          fontSize: "13px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "15px",
                          fontSize: "12px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "15px",
                          }}
                        >
                          <li>
                            Your designation revokes all prior designations.
                          </li>
                          <li>
                            Benefits are only payable to a contingent
                            Beneficiary if you are not survived by one or more
                            primary Beneficiary(ies).
                          </li>
                          <li>
                            If you name two or more Beneficiaries in a class:
                          </li>
                        </div>
                        <div>
                          <ol
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "15px",
                            }}
                          >
                            <li>
                              Two or more surviving Beneficiaries will share
                              equally, unless you provide for unequal shares.
                            </li>
                            <li>
                              If you provide for unequal shares in a class, and
                              two or more Beneficiaries in that class survive,
                              we will pay each surviving Beneficiary his or her
                              designated share. Unless you provide otherwise, we
                              will then pay the share(s) otherwise due to any
                              deceased Beneficiary(ies) to the surviving
                              Beneficiaries pro rata based on the relationship
                              that the designated percentage or fractional share
                              of each surviving Beneficiary bears to the total
                              shares of all surviving Beneficiaries.
                            </li>
                            <li>
                              If only one Beneficiary in a class survives, we
                              will pay the total death benefits to that
                              Beneficiary.
                            </li>
                          </ol>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "15px",
                          }}
                        >
                          <li>
                            If a minor (a person not of legal age), or your
                            estate, is the Beneficiary, it may be necessary to
                            have a guardian or a legal representative appointed
                            by the court before any death benefit can be paid.
                            If the Beneficiary is a trust or trustee, the
                            written trust must be identified in the Beneficiary
                            designation. For example, “Dorothy Q. Smith, Trustee
                            under the trust agreement dated .”
                          </li>
                          <li>
                            A power of attorney must grant specific authority,
                            by the terms of the document or applicable law, to
                            make or change a Beneficiary designation. If you
                            have any questions, consult your legal advisor.
                          </li>
                          <li>
                            Dependents Insurance, if any, is payable to you, if
                            living, or as provided under your Employer’s
                            coverage under the Group Policy.
                          </li>
                        </div>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
        {/* End of User details */}

        {/* Signature Model */}
        <CoverageEmployeeSign
          openCanvas={openCanvas}
          closeCanvas={closeCanvas}
          values={values}
          // onBlurHandler={onBlurHandler}
          setValues={setValues}
          keyName={"employeeSign"}
        />
      </Container>
    </Fragment>
  );
};

export default CoverageMain;
